<!--
    Panel wyboru serii/kolekcji sufitów Crystal/Tweed/Verde
-->

<i18n>
    {
    "en": {
    "select": "Select your pattern"
    },

    "fr": {
    "select": "Sélectionnez votre motif"
    },

    "pl": {
    "select": "Wybierz wzór"
    },

    "de": {
    "select": "Wählen Sie das Lochmuster"
    }

    }
</i18n>

<template>
    <div class="Series" :style="{ display: computedDiplay }">
        <button @click="changeSceneClick('crystal_8_a')" class="button-crystal" v-bind:class="{ active: isSerie('crystal') }">
            <span>Crystal</span>
            <img src="~@/assets/backgrounds/series_crystal_pattern.png" />
        </button>
        <button @click="changeSceneClick('tweed_10_10_a')" class="button-tweed" v-bind:class="{ active: isSerie('tweed') }">
            <span>Tweed</span>
            <img src="~@/assets/backgrounds/series_tweed_pattern.png" />
        </button>
        <button @click="changeSceneClick('verde_17_17_a')" class="button-verde" v-bind:class="{ active: isSerie('verde') }">
            <span>Verde</span>
            <img src="~@/assets/backgrounds/series_verde_pattern.png" />
        </button>
        <div class="series_top">
            {{ $t('select') }}
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Series',

        props: {
            scene: String
        },
        data() {
            return {
                serie: "verde"
            }
        },
        mounted: function () {

        },
        beforeUpdate: function () {
            this.serie = this.scene.split("_")[0]
        },
        computed: {
            computedDiplay: function () {
                return (this.scene.split("_")[0] == 'select') ? 'block' : 'none';
                //return 'block'; // TEMP
            }
        },
        methods: {
            changeSceneClick: function (val) {
                this.$root.$emit('changeSceneClick', val)
            },
            isSerie: function (val) {
                return (this.scene.split("_")[0] == val)
            }
        }
    };
</script>

<style scoped>
    .Series {
        position: absolute;
        z-index: 90;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        font-size: 1rem;
        color: #FFF;
        text-transform: uppercase;
    }

    .series_top {
        background: #434D56;
        width: 100%;
        height: 60px;
        position: absolute;
        top: 0;
        text-align: center;
        line-height: 60px;
        font-size: 1.25rem;
        margin: auto;
        clip-path: polygon(29% 0, 71% 0, 68% 60px, 32% 60px);
        text-transform: uppercase;
    }

    button {
        position: relative;
        border: none;
        width: calc(100%/3);
        display: inline-block;
        height: 100%;
        cursor: pointer;
        outline: none;
        box-sizing: border-box;
        background-position: center center;
        transition: all 0.5s ease;
        background-size: auto 100%;
    }

        button:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            display: block;
            width: 100%;
            height: 100%;
            transition: all 0.5s ease;
            opacity: .75;
        }

        button:hover {
            background-size: auto 120%;
        }

            button:hover:before {
                opacity: 0.5;
            }


        button span {
            position: relative;
            font-size: 3rem;
            color: #FFF;
            text-transform: uppercase;
        }

        button img {
            position: absolute;
            width: 42%;
            bottom: -4%;
            left: 29%;
        }

    .button-crystal {
        background-image: url('~@/assets/backgrounds/series_crystal_background.jpg');
    }

        .button-crystal:before {
            background: #76A1B1;
        }

        .button-crystal:after {
            /*content: url('~@/assets/backgrounds/series_crystal_pattern.png');*/
            /*background-image: url('~@/assets/backgrounds/series_crystal_pattern.png');*/
        }

    .button-tweed {
        background-image: url('~@/assets/backgrounds/series_tweed_background.jpg');
    }

        .button-tweed:before {
            background: #8D8F92;
        }

    .button-verde {
        background-image: url('~@/assets/backgrounds/series_verde_background.jpg');
    }

        .button-verde:before {
            background: #9CB493;
        }


    @media only screen and (max-device-width : 1024px) {
        .series_top {
            clip-path: polygon(0% 0, 100% 0, 91% 60px, 9% 60px);
        }

        button span {
            font-size: 1rem;
        }
    }
</style>